export default __webpack_public_path__ + "static/implied-motion-fab-dark-149170b805b28ba31096414df1167b34f7776dfb0f8061d5ec8c67eb31950485.mp4";